import React, { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import AlertContext from '../../context/alerts/alertContext';
import AuthContext from '../../context/auth/authContext';

const Login = ( props ) => {
    
    // Extracting values from alert context
    const alertContext = useContext(AlertContext);
    const { alert, showAlert } = alertContext;
    // Extracting values from auth context
    const authContext = useContext(AuthContext);
    const { message, authenticated, loginUSer } = authContext;

    // Error handling
    useEffect(() => {
        if(authenticated){
            props.history.push('/projects');
        }
        if(message){
            console.log(message.msg);
            showAlert(message.msg, message.category);
        }
        //eslint-disable-next-line
    }, [message, authenticated, props.history]);
    
    // Set state
    const [ user, setUser ] = useState({
        email: '',
        password: ''
    });

    const { email, password } = user;

    const onChange = (e) => {
        setUser({
            ...user,
            [ e.target.name ]: e.target.value
        });
    }

    const onSubmit = (e) => {
        e.preventDefault();

        // Validation for void fields
        if (email.trim() === '' || password.trim === ''){
            showAlert('All fields are required, please validate', 'alerta-error');
        }
        // Sending to action
        loginUSer({ email, password });

    }
    
    return ( 
        <div className="form-usuario">
             { alert ? ( <div className={ `alerta ${ alert.category }` }>{ alert.msg }</div> ) : null }
            <div className="contenedor-form sombra-dark">
                <h1>Login</h1>
                <form
                    onSubmit={ onSubmit }
                >
                    <div className="campo-form">
                        <label htmlFor="email">eMail:</label>
                        <input 
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Your email"
                            value={ email }
                            onChange={ onChange }
                        />
                    </div>
                    <div className="campo-form">
                        <label htmlFor="password">Password:</label>
                        <input 
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Your password"
                            value={ password }
                            onChange={ onChange }
                        />
                    </div>
                    <div className="campo-form">
                        <input 
                            type="submit"
                            className="btn btn-primario btn-block"
                            value="Login"
                        />
                    </div>
                </form>
                <Link to={ '/create-account' } className="enlace-cuenta">
                    Create an account
                </Link>
            </div>
        </div>
     );
}
 
export default Login;